<span [class]="enumValue | enumStyle: enumType"
      scOverflowTooltip>
  <i class="fas fa-circle text-sm mr-1"></i>
  <span class="font-bold">
    {{ enumValue | enumLocalize:enumType | uppercase }}
  </span>
</span>